<template>
  <div class="grid grid-cols-1 input-section" :class="customClass">
    <div class="flex items-center gap-2">
      <h1>{{ t('customPrices') }}</h1>
      <button
          class="px-3 rounded-lg bg-blue-200 hover:bg-blue-300 active:bg-blue-400 text-xl"
          type="button" @click="addItemCustomPrice">+
      </button>
    </div>
  </div>
  <div v-for="(item, i) of itemCustomPrices" :key="i" class="input-section border border-blue-300 p-2 my-1" :class="customClass">
    <div class="">
      <!-- <h1>{{ t('sections.pricing') }}</h1> -->
      <div class="input-group">
        <el-form-item :label="t('customPriceName')" class="input-label" style="margin: 5px auto">
          <el-select v-model="item.customPriceTypeID" filterable class="w-full">
            <el-option v-for="(cp, j) in customPriceTypes" :disabled="cp.disabled" :key="j" :label="$ctx.locale == 'en' ? cp.enName: cp.arName" :value="cp.id">

            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
            :label="t('salePriceAmount')"
            prop="salePriceAmount"
            class="input-label"
            style="margin: 5px auto"
        >
          <money-input
              id="sale-price"
              :currency="$ctx.currency"
              v-model="item.salePriceAmount"
              @dinero-created="(dinero) => (item.salePriceDinero = dinero)"
          />
        </el-form-item>
      </div>
    </div>

    <div class="">
      <div class="flex items-center justify-between">
        <div>
          <el-form-item prop="disabled" class="input-label" style="margin: 5px auto">
            <el-checkbox v-model="item.disabled" id="disabled">
              {{ t('disabled') }}
            </el-checkbox>
          </el-form-item>
        </div>
        <div v-if="!isValidDate(item?.createdAt)">
          <el-button @click="deleteItemPack(item)" text type="danger">{{ t('delete') }}</el-button>
        </div>
      </div>
    </div>

  </div>

</template>

<script setup lang="ts">
import {
  defineProps,
  defineEmits,
  nextTick,
  ref,
  onMounted,
  computed,
  onBeforeMount
} from 'vue'
import { ElInput } from 'element-plus'
import { useI18n } from 'vue-i18n'
import MoneyInput from "@/components/form/MoneyInput.vue";
import ItemPack from "@/models/inventory/ItemPack";
import { v4 as uuidv4 } from 'uuid'
import {Dinero as DineroType} from "dinero.js";
import {watch} from "vue-demi";
import Pack from "@/models/inventory/Pack";
import {useHTTP} from "@/plugins/http";
import CustomPriceType from "@/models/inventory/CustomPrice";
import ItemCustomPrice from "@/models/inventory/ItemCustomPrice";

// Define props
const props = defineProps({
  modelValue: Array<ItemPack>,
  customClass: String
})

const messages = {
  en: {
    customPrices: 'Custom Prices',
    customPriceName: 'Custom price name',
    delete: 'Delete',
  },
  ar: {
    customPrices: 'سعر مخصص',
    customPriceName: 'السعر المخصص',
    delete: 'حذف'

  }
}
const { t } = useI18n({ messages, useScope: 'global' })
const http = useHTTP()

const customPriceTypes = ref<Array<CustomPriceType>>([]);
const itemCustomPrices = ref<Array<ItemCustomPrice>>([]);

// Define emits
const emit = defineEmits(['update:modelValue'])

onBeforeMount(() => {
  loadPacks();
})

onMounted(() => {
  itemCustomPrices.value = props.modelValue ? props.modelValue: [];
})


watch(() => itemCustomPrices.value, (newValue) => {
  updateOptions()
  emit('update:modelValue', newValue)
}, {deep: true})

async function loadPacks() {
  try {
    customPriceTypes.value = await http.get<Array<CustomPriceType>>(CustomPriceType.ENDPOINT);
    nextTick(() => {
      updateOptions()
    })
  } catch (e) {
    console.log(e)
  }
}

function addItemCustomPrice() {
 const newCustomPrice = new ItemCustomPrice();
  newCustomPrice.id = uuidv4()
  itemCustomPrices.value.push(newCustomPrice)
}

function isCustomPriceTypeUsed(cp: CustomPriceType) {
  for (const i of itemCustomPrices.value) {
    if (i.customPriceTypeID == cp.id) {
      return true;
    }
  }
  return false;
}

function updateOptions() {
  customPriceTypes.value.map(p => {
    p.disabled = isCustomPriceTypeUsed(p);
    return p;
  })
}

function isValidDate(d: any) {
  return d instanceof Date && !isNaN(d);
}

function deleteItemPack(item: ItemPack) {
  itemCustomPrices.value = itemCustomPrices.value.filter(ip => ip.id != item.id);
}

</script>

<style scoped>
/* Add any styles you need here */
</style>
